import { render, staticRenderFns } from "./CreateFolder.vue?vue&type=template&id=3b5bf62e&scoped=true"
import script from "./CreateFolder.vue?vue&type=script&lang=js"
export * from "./CreateFolder.vue?vue&type=script&lang=js"
import style0 from "./CreateFolder.vue?vue&type=style&index=0&id=3b5bf62e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5bf62e",
  null
  
)

export default component.exports